import { render, staticRenderFns } from "./CheckoutTipSection.vue?vue&type=template&id=32765bd4"
import script from "./CheckoutTipSection.vue?vue&type=script&lang=js"
export * from "./CheckoutTipSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports